import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { intlShape } from 'react-intl'
import { Helmet } from 'react-helmet'
import classNames from 'classnames'

import { getStory as getStoryAction } from './storyActions'
import Loader from '../../components/loader/Loader'
import { clearPlayqueue as clearPlayqueueAction } from '../../components/miniPlayer/AudioPlayer/playerActions'
import * as selectors from './storySelectors'
import * as shapes from '../../constant/shapes'
import * as playerSelectors from '../../components/miniPlayer/miniPlayerSelectors'
import ShareComponent from '../../components/share/ShareComponent'
import GTMController from "../../utils/kpi/GTMController"
import appConst from '../../constant/appConst'
import ReadMoreComponent from '../../components/ReadMoreComponent'
import { ORIGIN_PLAYQUEUE_TYPES } from '../../components/miniPlayer/AudioPlayer/playerConstants'
import StoryAlbumCard from './subComponents/StoryAlbumCard'

class StoryPage extends PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      defaultCardHeight: null,
      defaultImageHeight: null
    }
    this.setCardsSizes = this.setCardsSizes.bind(this)
    this.onResize = this.onResize.bind(this)
  }

  componentWillMount() {
    const { location, getStory } = this.props
    getStory(location.id, location.type)
  }

  componentDidMount() {
    this.setCardsSizes()
    window.addEventListener('resize', this.onResize, false)
  }

  componentWillUnmount() {
    this.props.clearPlayqueue()
    window.removeEventListener('resize', this.onResize, false)
  }

  componentWillReceiveProps(nextProps) {
    const { id } = this.props
    if (id !== nextProps.id) {
      this.props.clearPlayqueue()
    }
    if (nextProps.titleContainer.title) {
      GTMController.pushStoryPageEvent(nextProps.titleContainer.author, nextProps.titleContainer.title)
    }
  }

  onResize() {
    this.setCardsSizes()
  }

  setCardsSizes() {
    const metaHeight = 54
    const albums = document.querySelectorAll('.albums-generic-grid-list > .item')
    if (albums) {
      const firstAlbum = albums[0]
      if (firstAlbum) {
        const cardWith = +firstAlbum.clientWidth
        this.setState({
          defaultImageHeight: cardWith - 2, // 1px border
          defaultCardHeight: cardWith + metaHeight
        })
      }
    }
  }

  render() {

    const { titleContainer, imageContainer, content, id, isCurrentTrack, isPlaying } = this.props
    const { intl } = this.context

    let shouldDisplayLettrine = true

    const crawlerData = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "NewsArticle",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": `https://open.qobuz.com/story/${id}`
      },
      "isAccessibleForFree": "False",
      "hasPart": {
        "@type": "WebPageElement",
        "isAccessibleForFree": "False",
        "cssSelector": ".story__content"
      }
    })

    return (
      <Loader>
        <div className="page">
          <Helmet>
            <title>{intl.formatMessage({ id: 'title.story' })}</title>
            <script type="application/ld+json">{crawlerData}</script>
            <link rel="canonical" href={`https://open.qobuz.com/story/${id}`} />
          </Helmet>

          <div className="story">

            <div className="story__heading">

              <div className="story__background">
                {imageContainer && <div className="story__cover" style={{ backgroundImage: `url(${imageContainer.image})` }} />}
                <div className="story__gradient" />
              </div>
              <div className="story__meta">
                <h1 className="story__title">{titleContainer.title}</h1>
                <p
                  className="story__author">{intl.formatMessage({ id: 'story.from' }, { author: titleContainer.author })}</p>
                {titleContainer.date &&
                  <p className="story__date">
                    {intl.formatDate(titleContainer.date, {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric'
                    })}
                  </p>
                }
              </div>
              <ShareComponent
                GTMCopyEvent={GTMController.EVENTS.STORY_SHARE}
                className="story__button pct pct-share"
              />
              <ShareComponent
                GTMCopyEvent={GTMController.EVENTS.STORY_SHARE}
                className="story__button story__button--header pct pct-share"
              />

            </div>

            {titleContainer.accroche &&
              <p className="story__intro" dangerouslySetInnerHTML={{ __html: `${titleContainer.accroche}`.nl2br() }} />}
            {content.map((container, key) => {
              switch (container.type) {
                case appConst.story.layout.text:
                  const classes = classNames('story__content story__content--text', {
                    lettrine: shouldDisplayLettrine
                  })
                  shouldDisplayLettrine = false
                  return (
                    <p key={`story-container-${key}`} className={classes}>
                      {container.descriptions.map(description => (
                        <span
                          dangerouslySetInnerHTML={{ __html: `${description}`.nl2br() }}
                          className="story__text"
                        />
                      ))}
                    </p>
                  )
                case appConst.story.layout.carousel:
                  let albumList = []
                  if (container.albums && container.albums.items && container.albums.items.length) {
                    console.log(container.number_col, container.number_raw)
                    albumList = container.albums.items.slice(0, appConst.story.maxAlbums)
                  }
                  // to get even number 
                  const nbItemPerCol = 2 * Math.round(albumList.length / 4)
                  return (
                    <section key={`story-container-${key}`} className="carousel">
                      <div className="carousel__titles">
                        <p className="carousel__title">{container.title}</p>
                        {container.subtitle &&
                          <p className="carousel__subtitle">{container.subtitle}</p>
                        }
                      </div>
                      <div className={`carousel__cards col-${nbItemPerCol}`}>
                        {albumList.map((album, index) => <StoryAlbumCard
                          forceCardHeight={this.state.defaultCardHeight}
                          forceImageHeight={this.state.defaultImageHeight}
                          key={`album-${index}`}
                          GTMPlayEvent={GTMController.EVENTS.STORY_PLAY}
                          current={isCurrentTrack(ORIGIN_PLAYQUEUE_TYPES.album, album.id)}
                          playing={isPlaying}
                          album={album}
                        />)}
                      </div>
                      <p className="carousel__text">{intl.formatMessage({ id: 'story.joinQobuz' })}</p>
                      <ReadMoreComponent id={id} type="story" className="carousel__button" />
                    </section>
                  )
              }
            })}
          </div>
        </div>
      </Loader>
    )
  }

}

StoryPage.propTypes = {
  location: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string
  }),
  id: PropTypes.string,
  content: PropTypes.arrayOf(shapes.storyContent),
  titleContainer: shapes.storyTitle,
  imageContainer: shapes.storyImage,
  isCurrentTrack: PropTypes.func,
  isPlaying: PropTypes.bool,
  clearPlayqueue: PropTypes.func
}

StoryPage.contextTypes = {
  intl: intlShape
}

const mapStateToProps = (state, ownProps) => ({
  location: {
    id: ownProps.params.id,
    type: ownProps.params.type
  },
  id: selectors.getStoryId(state),
  titleContainer: selectors.getStoryTitle(state),
  imageContainer: selectors.getStoryImage(state),
  content: selectors.getStoryContent(state),
  isCurrentTrack: playerSelectors.isCurrentTrack(state),
  isPlaying: playerSelectors.isPlaying(state)
})

const actions = {
  getStory: getStoryAction,
  clearPlayqueue: clearPlayqueueAction
}

export default connect(mapStateToProps, actions)(StoryPage)



// WEBPACK FOOTER //
// ./src/pages/story/StoryPage.jsx